import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  getDynamicPricingSectionHeaderSubtitleSx,
  getDynamicPricingSectionHeaderTitleSx,
} from '../../utils/dynamicPricingTheme';

/** Shared tab title row — matches Stock section headers. */
export default function DynamicPricingTabHeader({ title, description, action }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'minmax(0, 1fr) auto' },
        gap: 2,
        alignItems: 'start',
        mb: 3,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" component="h2" sx={getDynamicPricingSectionHeaderTitleSx(isDark)}>
          {title}
        </Typography>
        {description ? (
          <Typography variant="body2" sx={{ ...getDynamicPricingSectionHeaderSubtitleSx(isDark), mt: 0.5, lineHeight: 1.55 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      {action ? (
        <Box sx={{ justifySelf: { xs: 'stretch', sm: 'end' }, width: { xs: '100%', sm: 'auto' } }}>
          {action}
        </Box>
      ) : null}
    </Box>
  );
}
